<div class="page-container" [class.embedded-mode]="embeddedMode" [testId]="'tenant-ip-range-container'">
  <div class="page-topbar" [testId]="'tenant-ip-range-header-section'">
    <div class="page-header" [testId]="'tenant-ip-range-title-row'">
      <div class="page-heading" [testId]="'tenant-ip-range-title-section'">
        <h3 class="page-title" [testId]="'tenant-ip-range-title'">{{ 'tenant.employee.tab.ip-range' | i18n }}</h3>
      </div>
      <div class="page-actions" [testId]="'tenant-ip-range-actions'">
        <button
          nz-button
          nzType="default"
          nzDanger
          [disabled]="selectedIds.size === 0"
          (click)="deleteBatch()"
          class="batch-delete-btn"
          [testId]="'tenant-ip-range-batch-delete-btn'"
        >
          <i nz-icon nzType="delete"></i>
          <span>
            {{
              selectedIds.size > 0
                ? ('tenant.ip-range.batch-delete-count' | i18n: { count: selectedIds.size })
                : ('tenant.ip-range.batch-delete' | i18n)
            }}
          </span>
        </button>

        <button
          nz-button
          nzType="primary"
          (click)="openBatchAddModal()"
          class="create-button batch-add-btn"
          [testId]="'tenant-ip-range-batch-add-btn'"
        >
          <i nz-icon nzType="plus"></i>
          <span>{{ 'tenant.ip-range.batch-add' | i18n }}</span>
        </button>
      </div>
    </div>

    <div class="topbar-search" [testId]="'tenant-ip-range-toolbar'">
      <div class="topbar-search-row" [testId]="'tenant-ip-range-search-group'">
        <div class="search-input" [testId]="'tenant-ip-range-search-wrapper'">
          <input
            nz-input
            type="text"
            [placeholder]="'tenant.ip-range.search-placeholder' | i18n"
            [(ngModel)]="searchKeyword"
            (keydown.enter)="onSearch()"
            class="search-input-control"
            [testId]="'tenant-ip-range-search-input'"
          />
          <button
            type="button"
            class="search-trigger"
            nz-tooltip
            [nzTooltipTitle]="'tenant.ip-range.search-tooltip' | i18n"
            (click)="onSearch()"
            [testId]="'tenant-ip-range-search-btn'"
          >
            <i nz-icon nzType="search" class="search-icon"></i>
          </button>
        </div>

        <div class="toolbar-controls">
          <button nz-button nzType="default" class="reset-button" (click)="resetSearch()" [testId]="'tenant-ip-range-reset-btn'">
            <i nz-icon nzType="clear"></i>
            <span>{{ 'tenant.ip-range.clear' | i18n }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="page-scroll" [testId]="'tenant-ip-range-content'">
    <div class="result-meta" [testId]="'tenant-ip-range-meta-bar'">
      <div class="result-count" [testId]="'tenant-ip-range-total-text'">
        {{ 'tenant.ip-range.total-records' | i18n: { total: total } }}
      </div>
    </div>

    <div class="batch-selection-bar" *ngIf="selectedIds.size > 0" [testId]="'tenant-ip-range-selection-bar'">
      <div class="selection-info">
        <i nz-icon nzType="info-circle" nzTheme="outline" class="selection-icon"></i>
        <span [testId]="'tenant-ip-range-selected-text'">
          {{ 'tenant.ip-range.selected-count' | i18n: { count: selectedIds.size } }}
        </span>
      </div>
      <div class="selection-actions">
        <button nz-button nzType="default" class="batch-delete-btn" (click)="deleteBatch()">
          <i nz-icon nzType="delete"></i>
          <span>{{ 'tenant.ip-range.batch-delete' | i18n }}</span>
        </button>
        <button nz-button nzType="link" class="batch-clear-selection-btn" (click)="clearSelection()">
          {{ 'tenant.employee.clear-selection' | i18n }}
        </button>
      </div>
    </div>

    <div class="content-section" [testId]="'tenant-ip-range-table-section'">
      <div class="table-section">
        <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n" [testId]="'tenant-ip-range-spin'">
          <nz-table
            #ipTable
            [nzData]="displayedListOfData"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            nzSize="middle"
            class="table-container ip-range-table"
            [testId]="'tenant-ip-range-table'"
          >
            <thead>
              <tr>
                <th
                  scope="col"
                  nzWidth="50px"
                  [nzChecked]="isAllCurrentPageSelected"
                  [nzIndeterminate]="isIndeterminate"
                  (nzCheckedChange)="onAllChecked($event)"
                  [testId]="'tenant-ip-range-header-checkbox'"
                ></th>
                <th scope="col" nzWidth="220px" [testId]="'tenant-ip-range-header-ip'">
                  {{ 'tenant.ip-range.col.ip' | i18n }}
                </th>
                <th scope="col" [testId]="'tenant-ip-range-header-remark'">
                  {{ 'tenant.ip-range.col.remark' | i18n }}
                </th>
                <th scope="col" nzWidth="160px" [testId]="'tenant-ip-range-header-creator'">
                  {{ 'tenant.ip-range.col.creator' | i18n }}
                </th>
                <th scope="col" nzWidth="180px" [testId]="'tenant-ip-range-header-create-time'">
                  {{ 'tenant.ip-range.col.create-time' | i18n }}
                </th>
                <th scope="col" nzWidth="100px" class="text-center" [testId]="'tenant-ip-range-header-actions'">
                  {{ 'tenant.ip-range.col.actions' | i18n }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of ipTable.data; trackBy: trackByIpId"
                [attr.data-testid]="'tenant-ip-range-table-row-' + item.id"
                [testId]="'tenant-ip-range-table-row-' + item.id"
                [class.selected-row]="selectedIds.has(item.id)"
              >
                <td
                  [nzChecked]="selectedIds.has(item.id)"
                  (nzCheckedChange)="onItemChecked(item.id, $event)"
                  [testId]="'tenant-ip-range-cell-checkbox-' + item.id"
                ></td>
                <td [testId]="'tenant-ip-range-cell-ip-' + item.id">
                  <div class="ip-display-cell">
                    <span class="ip-code">{{ item.publicIp || item.normalizedPublicIp }}</span>
                    <nz-tag class="ip-type-tag" [nzColor]="(item.publicIp || item.normalizedPublicIp)?.includes(':') ? 'purple' : 'blue'">
                      {{ (item.publicIp || item.normalizedPublicIp)?.includes(':') ? 'IPv6' : 'IPv4' }}
                    </nz-tag>
                  </div>
                </td>
                <td [testId]="'tenant-ip-range-cell-remark-' + item.id">
                  <span class="remark-text">{{ item.remark || '-' }}</span>
                </td>
                <td [testId]="'tenant-ip-range-cell-creator-' + item.id">
                  <span class="creator-text">{{ item.creatorName || item.creatorId || '-' }}</span>
                </td>
                <td [testId]="'tenant-ip-range-cell-create-time-' + item.id">
                  <span class="date-text">{{ (item.createTime | date: 'yyyy-MM-dd HH:mm:ss') || item.createTime || '-' }}</span>
                </td>
                <td class="text-center action-cell" [testId]="'tenant-ip-range-cell-actions-' + item.id">
                  <button
                    nz-button
                    nzType="link"
                    nzDanger
                    nzSize="small"
                    class="action-button delete-button dangerous-action"
                    nz-popconfirm
                    [nzPopconfirmTitle]="'tenant.ip-range.delete-confirm-single' | i18n"
                    (nzOnConfirm)="deleteSingle(item)"
                    [testId]="'tenant-ip-range-delete-btn-' + item.id"
                  >
                    <i nz-icon nzType="delete"></i>
                    <span>{{ 'tenant.ip-range.action.delete' | i18n }}</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </nz-spin>
      </div>

      <div class="content-footer" *ngIf="total > 0" [testId]="'tenant-ip-range-pagination-bar'">
        <div class="pagination-section">
          <div class="pagination-info" [testId]="'tenant-ip-range-total-info'">
            {{ 'tenant.ip-range.total-records' | i18n: { total: total } }}
          </div>
          <div class="pagination-controls">
            <nz-pagination
              [nzPageIndex]="pageIndex"
              [nzTotal]="total"
              [nzPageSize]="pageSize"
              [nzShowSizeChanger]="true"
              [nzPageSizeOptions]="[10, 20, 50, 100]"
              (nzPageIndexChange)="pageIndexChange($event)"
              (nzPageSizeChange)="pageSizeChange($event)"
              nzSize="small"
              [testId]="'tenant-ip-range-pagination'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 批量新增 Modal -->
<nz-modal
  [(nzVisible)]="batchAddVisible"
  [nzTitle]="'tenant.ip-range.modal.add-title' | i18n"
  (nzOnCancel)="closeBatchAddModal()"
  (nzOnOk)="submitBatchAdd()"
  [nzOkLoading]="batchAddLoading"
  [nzWidth]="540"
  [testId]="'tenant-ip-range-batch-add-modal'"
>
  <ng-container *nzModalContent>
    <form [formGroup]="batchAddForm" class="modal-form" [testId]="'tenant-ip-range-modal-form'">
      <div class="form-field-group">
        <label class="form-label required">
          {{ 'tenant.ip-range.modal.ip-list' | i18n }}
        </label>
        <textarea
          nz-input
          rows="6"
          formControlName="ips"
          [placeholder]="'tenant.ip-range.modal.ip-placeholder' | i18n"
          class="ip-textarea"
          [testId]="'tenant-ip-range-modal-textarea'"
        ></textarea>
        <div class="field-hints">
          <span class="hint-tip">
            <i nz-icon nzType="info-circle" nzTheme="outline"></i>
            {{ 'tenant.ip-range.modal.ip-tip' | i18n }}
          </span>
          <span class="count-tip" *ngIf="detectedIpCount > 0">
            {{ 'tenant.ip-range.modal.ip-count-detected' | i18n: { count: detectedIpCount } }}
          </span>
        </div>
      </div>

      <div class="form-field-group">
        <label class="form-label">
          {{ 'tenant.ip-range.modal.remark' | i18n }}
        </label>
        <input
          nz-input
          type="text"
          formControlName="remark"
          [placeholder]="'tenant.ip-range.modal.remark-placeholder' | i18n"
          maxlength="100"
          [testId]="'tenant-ip-range-modal-remark'"
        />
      </div>
    </form>
  </ng-container>
</nz-modal>
